interface FilterConfig<T> {
  rawData: T[];
  value: string;
  optionFilter: string[];
}

export class FilterData<T> {
  private filterConfig: FilterConfig<T>;
  private processedData: any[] = [];

  public static start<T>({ rawData, value, optionFilter }: FilterConfig<T>): T[] {
    const entity = new FilterData<T>();
    entity.filterConfig = { rawData, value, optionFilter };
    entity.addIndex().filter().removeDuplicate().removeIndex();
    return entity.processedData;
  }

  private addIndex(): this {
    this.filterConfig.rawData = this.filterConfig.rawData.map((t, index) => ({ ...t, index }));
    return this;
  }

  private filter(): this {
    const { rawData, optionFilter } = this.filterConfig;

    for (let property of optionFilter) {
      for (let element of rawData) {
        this.filterSimple(element, property);
        this.filterCompound(element, property);
      }
    }
    return this;
  }

  private removeDuplicate(): this {
    const listIndex = [];
    this.processedData = this.processedData.reduce((acc: T[], item) => {
      if (!listIndex.includes(item.index)) {
        acc.push(item);
        listIndex.push(item.index);
      }
      return acc;
    }, [] as T[]);
    return this;
  }

  private removeIndex(): this {
    this.processedData = this.processedData?.map((t: { index: number }) => {
      delete t.index;
      return t;
    });
    return this;
  }

  private filterSimple(element: T, propertyKey: string): void {
    const { value } = this.filterConfig;
    if (typeof element[propertyKey] === "string") {
      const data = this.filterValue(value, element, propertyKey);
      if (data) {
        this.processedData.push(element);
      }
    }
  }

  private filterCompound(element: T, property: string): void {
    const { value } = this.filterConfig;
    const [arrayProperty, propertyKey] = property.split(".");
    if (!arrayProperty && !propertyKey) return;

    if (typeof element[arrayProperty] === "object" && element[arrayProperty].length) {
      const data: T[] = element[arrayProperty].filter((item: T) => this.filterValue(value, item, propertyKey));
      if (data.length) {
        this.processedData.push(element);
      }
    }
  }

  private filterValue(value: string, item: T, propertyKey: string): boolean {
    return Boolean(this.textToLowerCase(item[propertyKey]).includes(this.textToLowerCase(value)));
  }

  private textToLowerCase(text: string): string {
    return text.toLocaleLowerCase();
  }
}
